import { useState, type ReactNode } from 'react';
import { Input, Checkbox, Button } from 'antd';
import {
  SearchOutlined, UsergroupAddOutlined, ContactsOutlined, FileTextOutlined,
  WhatsAppOutlined, FacebookFilled, InstagramOutlined, GlobalOutlined,
} from '@ant-design/icons';
import '../groupSelect/styles.scss';

interface Source {
  id:    string;
  label: string;
  icon:  ReactNode;
}

interface Props {
  open:      boolean;
  onClose:   () => void;
  onSelect?: (ids: string[]) => void;
  selected?: string[];
}

const SOURCES: Source[] = [
  { id: 'manual',    label: 'Manually Created',      icon: <UsergroupAddOutlined /> },
  { id: 'phonebook', label: 'Imported from Phonebook', icon: <ContactsOutlined /> },
  { id: 'csv',       label: 'Imported from CSV',      icon: <FileTextOutlined /> },
  { id: 'whatsapp',  label: 'Imported from WhatsApp', icon: <WhatsAppOutlined style={{ color: '#25d366' }} /> },
  { id: 'facebook',  label: 'Facebook',              icon: <FacebookFilled style={{ color: '#1877f2' }} /> },
  { id: 'instagram', label: 'Instagram',            icon: <InstagramOutlined style={{ color: '#e1306c' }} /> },
  { id: 'website',   label: 'Website',              icon: <GlobalOutlined /> },
];

const SourceSelect = ({ open, onClose, onSelect, selected = [] }: Props) => {
  const [search, setSearch] = useState('');
  const [picked, setPicked] = useState<string[]>(selected);

  const filtered = SOURCES.filter(s => s.label.toLowerCase().includes(search.toLowerCase()));

  const toggle = (id: string) =>
    setPicked(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]));

  const handleDone = () => {
    onSelect?.(picked);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="group-select">
      <div className="gs-search">
        <Input
          placeholder="Search Lead Sources"
          prefix={<SearchOutlined style={{ color: '#999' }} />}
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="gs-list">
        {filtered.map(s => (
          <div key={s.id} className="gs-item" onClick={() => toggle(s.id)}>
            <span className="gs-src-icon">{s.icon}</span>
            <span className="gs-label">{s.label}</span>
            <Checkbox
              checked={picked.includes(s.id)}
              onClick={e => e.stopPropagation()}
              onChange={() => toggle(s.id)}
            />
          </div>
        ))}

        {filtered.length === 0 && <div className="gs-empty">No lead sources found</div>}
      </div>

      <div className="gs-done">
        <Button type="primary" block size="large" onClick={handleDone}>
          ✓ DONE
        </Button>
      </div>
    </div>
  );
};

export default SourceSelect;
